import { createSelector } from "@reduxjs/toolkit";
import { useTranslation } from "react-i18next";
import viewTitle from "views/logic/views/ViewTitle";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectView, selectViewType } from "views/logic/slices/viewSelectors";
const selectSavedTitle = createSelector(selectView, (view) => view == null ? void 0 : view.title);
const useViewTitle = () => {
  useTranslation("search");
  const title = useViewsSelector(selectSavedTitle);
  const viewType = useViewsSelector(selectViewType);
  return viewTitle(title, viewType);
};
export default useViewTitle;
